import React from 'react'
import { Col, List, Row } from 'antd'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import { Policy } from 'src/types'
import { Switch } from 'src/components/Formik'
import { Text, Title } from 'src/components/Ant'

import { AntiFraudTitleTooltipHint } from './anti-fraud-title-tooltip-hint'
import { ResourcesTitleTooltipHint } from './resources-title-tooltip-hint'
import { ServicesTitleTooltipHint } from './services-title-tooltip-hint'
import * as CSS from './styles'

interface ServicesResourcesProps {
  formikProps: FormikProps<Policy>
  policyRuleIndex: number
}

export default function ServicesResources({
  formikProps,
  policyRuleIndex
}: ServicesResourcesProps) {
  const { t } = useTranslation()

  return (
    <Row gutter={24}>
      <Col span={12}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <CSS.Title>
              <Title level={4} title="web.services.title" />
              <ServicesTitleTooltipHint />
            </CSS.Title>
            <List
              bordered
              dataSource={[
                {
                  key: 'enable_flight',
                  title: 'web.services.airs.title'
                },
                {
                  key: 'enable_hotel',
                  title: 'web.services.hotels.title'
                },
                {
                  key: 'enable_vehicle_rent',
                  title: 'web.services.vehicle.title'
                },
                {
                  key: 'enable_advance',
                  title: 'web.services.advances.title'
                }
              ]}
              renderItem={item => (
                <List.Item>
                  <Text strong>{t(item.title)}</Text>
                  <CSS.FormItem style={{ justifyContent: 'flex-end' }}>
                    <Switch
                      checkedChildren={t('common.enabled')}
                      formikProps={formikProps}
                      name={`policy_rules.${policyRuleIndex}.${item.key}`}
                      unCheckedChildren={t('common.disabled')}
                    />
                  </CSS.FormItem>
                </List.Item>
              )}
            />
          </Col>
        </Row>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <CSS.Title>
              <Title level={4} title="web.anti-fraud.title-section" />
              <AntiFraudTitleTooltipHint />
            </CSS.Title>
            <List
              bordered
              dataSource={[
                {
                  key: 'enable_qr_code',
                  title: 'web.anti-fraud.enable-qr-code'
                },
                {
                  key: 'enable_qr_code_check_vat',
                  title: 'web.anti-fraud.enable-qr-code-check-vat'
                },
                {
                  key: 'enable_receipt_antifraud',
                  title: 'web.anti-fraud.enable-receipt-anti-fraud'
                },
                {
                  key: 'qrcode_retroative_date',
                  title: 'web.anti-fraud.qr-code-retroative-date'
                },
                {
                  key: 'qrcode_show_antifraud',
                  title: 'web.anti-fraud.qr-code-show-anti-fraud'
                },
                {
                  key: 'enable_qr_code_check_diferent_vat',
                  title: 'web.anti-fraud.enable-qr-code-check-different-vat'
                }
              ]}
              renderItem={item => (
                <List.Item>
                  <Text strong>{t(item.title)}</Text>
                  <CSS.FormItem style={{ justifyContent: 'flex-end' }}>
                    <Switch
                      checkedChildren={t('common.enabled')}
                      formikProps={formikProps}
                      name={`policy_rules.${policyRuleIndex}.${item.key}`}
                      unCheckedChildren={t('common.disabled')}
                    />
                  </CSS.FormItem>
                </List.Item>
              )}
            />
          </Col>
        </Row>
      </Col>
      <Col span={12}>
        <CSS.Title>
          <Title level={4} title="web.resources.title-plural" />
          <ResourcesTitleTooltipHint />
        </CSS.Title>
        <List
          bordered
          dataSource={[
            {
              key: 'enable_standard_sharing',
              title: 'web.assignment.sharing.list-title'
            },
            {
              key: 'enable_standard_billing',
              title: 'web.assignment.billing.title'
            },
            {
              key: 'enable_itinerary',
              title: 'web.itinerary.title'
            },
            {
              key: 'enable_checkin',
              title: 'web.policies.rules.services.check-in'
            },
            {
              key: 'enable_nps',
              title: 'common.nps.title'
            },
            {
              key: 'disable_advance_retroactive',
              title: 'web.advance.policy.active-switch'
            },
            {
              key: 'enable_budget',
              title: 'web.policies.rules.services.budget'
            },
            {
              key: 'force_image',
              title: 'web.receipts.policy-violated.force-image-required'
            }
          ]}
          renderItem={item => (
            <List.Item>
              <Text strong>{t(item.title)}</Text>
              <CSS.FormItem>
                <Switch
                  checkedChildren={t('common.enabled')}
                  formikProps={formikProps}
                  name={`policy_rules.${policyRuleIndex}.${item.key}`}
                  unCheckedChildren={t('common.disabled')}
                />
              </CSS.FormItem>
            </List.Item>
          )}
        />
      </Col>
    </Row>
  )
}
